import '../styles/map.css'
import React, { Suspense, lazy, useMemo, useState } from 'react'
import { Placeholder } from 'reactstrap'
import Loader from './Loader'

const SkeletonIcon = lazy(() => import('./SkeltetonIcon'))
const BetterSkeleton = lazy(() => import('./BetterSkeleton'))

const Skeleton = ({ demographics, interests }: { demographics: string[]; interests: string[] }) => {
    const [pathList, setPathList] = useState([])

    const [infoTooltip, setInfoTooltip] = useState(null)

    const interestsInfo = useMemo(() => {
        return interests
            ? interests.map((x) => {
                  return { title: 'Interest', value: x }
              })
            : []
    }, [interests])

    const demographicsInfo = useMemo(() => {
        return demographics
            ? demographics.map((x) => {
                  return { title: 'Demographic', value: x }
              })
            : []
    }, [demographics])

    return (
        <div className="map mt-5 h-100">
            <div className="d-flex justify-content-center align-items-center overflow-hidden h-100">
                <Suspense
                    fallback={
                        <Placeholder style={{ height: '500px' }} className="bg-white">
                            <Loader absolutePosition={false} />
                        </Placeholder>
                    }
                >
                    <SkeletonIcon
                        setPathList={(list: string[]) => {
                            setPathList(list)
                        }}
                    />
                    <BetterSkeleton
                        pathList={pathList}
                        handleMouseOver={(info: { title: string; value: string }) => {
                            setInfoTooltip(info)
                        }}
                        handleMouseLeave={() => {
                            setInfoTooltip(null)
                        }}
                        infoValues={[...demographicsInfo, ...interestsInfo]}
                    />
                </Suspense>
            </div>
            <div className={infoTooltip ? 'category-tooltip' : 'category-tooltip-hidden'}>
                <span className={infoTooltip ? 'tooltip-header' : 'tooltip-header-hidden'}>{infoTooltip?.title}</span>
                <span className="tooltip-main">{infoTooltip?.value}</span>
            </div>
        </div>
    )
}

const MapBlock = ({ demographics, interests }: { demographics: string[]; interests: string[] }) => {
    return (
        <div className="map_block w-100">
            <Skeleton demographics={demographics} interests={interests} />
        </div>
    )
}

export default MapBlock
